import { ActivityEntityName, MetadataEntityData } from '@jms/model';
import { EntityMetadataService } from '@jms/utils/util.metadata';
import { lastValueFrom } from 'rxjs';

// Metadata the queue editor wizard needs, keyed by every entity a queue can target. Shared by the
// inbox store and the settings edit dialog so both editors see the same field catalogue.

const QUEUE_ENTITY_TARGETS: ActivityEntityName[] = [ActivityEntityName.Job, ActivityEntityName.Flag, ActivityEntityName.Invoice, ActivityEntityName.Bill];

export async function loadQueueMetadataMap(metadataService: Pick<EntityMetadataService, 'getEntity'>): Promise<Record<string, MetadataEntityData>> {

  const results = await Promise.all(QUEUE_ENTITY_TARGETS.map(entity => lastValueFrom(metadataService.getEntity(entity)).catch(() => null)));
  const map: Record<string, MetadataEntityData> = {};
  QUEUE_ENTITY_TARGETS.forEach((entity, index) => { if (results[index]) map[entity] = results[index]; });
  // Stage queues are filtered with job metadata: stages are embedded in the job document.
  if (map[ActivityEntityName.Job]) {
    map[ActivityEntityName.JobStages] = map[ActivityEntityName.Job];
    map[ActivityEntityName.WorkOrder] = map[ActivityEntityName.Job];
  }
  return map;
}
